import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { blacklistBoards } from '@/mocks/homeData';

export default function BlacklistBoard() {
  const [boardKey, setBoardKey] = useState(blacklistBoards[0].key);
  const board = blacklistBoards.find((item) => item.key === boardKey) ?? blacklistBoards[0];

  return (
    <section id="blacklist" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="分区 02 · 避雷名单"
          title="避雷名单速览：按争议浓度排一排"
          desc="避雷指数由讨论量、争议持续时长与回应方式综合整理，只用于描述当前讨论热度，不等于对任何人的定性判断。"
          actionLabel="榜单说明"
          actionHref="#radar"
        />

        <div className="mt-8 inline-flex items-center gap-1 rounded-full border border-foreground-200 bg-background-100 p-1">
          {blacklistBoards.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setBoardKey(item.key)}
              className={
                item.key === boardKey
                  ? 'whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 font-label text-sm text-background-50'
                  : 'whitespace-nowrap rounded-full px-4 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-200'
              }
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="mt-7 overflow-hidden rounded-lg border border-foreground-200/80">
          <div className="hidden grid-cols-[64px_1.1fr_1.6fr_150px] items-center gap-4 border-b border-foreground-200/80 bg-background-100 px-5 py-3 font-label text-[12px] tracking-wide text-foreground-500 lg:grid">
            <span>序号</span>
            <span>人物 / 身份</span>
            <span>被提及的主要原因</span>
            <span>避雷指数</span>
          </div>

          <ul>
            {board.entries.map((entry) => (
              <li
                key={`${board.key}-${entry.rank}`}
                className="border-b border-foreground-200/70 bg-background-50 px-4 py-5 transition-colors duration-200 last:border-b-0 hover:bg-background-100 md:px-5"
              >
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-[64px_1.1fr_1.6fr_150px] lg:items-center">
                  <span className="font-heading text-lg font-bold text-primary-500">
                    {entry.rank}
                  </span>

                  <div>
                    <h4 className="font-heading text-base font-bold text-foreground-950">
                      {entry.name}
                    </h4>
                    <p className="mt-0.5 font-label text-[12px] text-foreground-500">
                      {entry.identity}
                    </p>
                  </div>

                  <div>
                    <p className="text-sm leading-relaxed text-foreground-700">{entry.reason}</p>
                    <div className="mt-2.5 flex flex-wrap items-center gap-2">
                      {entry.tags.map((tag) => (
                        <span
                          key={tag}
                          className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <div className="flex items-baseline gap-1.5">
                      <span className="font-heading text-xl font-bold text-foreground-950">
                        {entry.heat}
                      </span>
                      <span className="font-label text-[11px] text-foreground-500">/ 100</span>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${entry.heat}%` }}
                      />
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <p className="mt-4 font-label text-[12px] leading-relaxed text-foreground-500">
          名单仅反映公开讨论的集中程度，人物均以去标识化代号呈现。若你认为条目存在事实偏差，可通过页脚的内容纠错入口反馈。
        </p>
      </div>
    </section>
  );
}